export const voidResponse = [
  {
    checkNumber: '5001',
    voidDate: '2021-11-01',
    timeStamp: 'xxxxx0',
    error: ''
  },
  {
    checkNumber: '5002',
    voidDate: '2021-12-01',
    timeStamp: 'xxxxx1',
    error: ''
  },
  {
    checkNumber: '5003',
    voidDate: '2021-08-01',
    timeStamp: 'xxxxx',
    error: 'this void failed'
  },
  {
    checkNumber: '5004',
    voidDate: '2021-07-01',
    timeStamp: 'xxxxx',
    error: 'this void failed'
  }
];
